import { regen } from "../utils/axios";

export const getLiveBannerCoupons = async () => {
  const response = await regen.get("/coupons/liveBannerCoupons");
  return response.data;
};
